import { useCallback } from "react";
import { useLocation } from "react-router-dom";

import {
  applyKaiFeedFilters,
  type KaiFeedFiltersPatch,
} from "@/features/feed/feedKaiFilters";

/**
 * Applies a feed-scope patch requested by Kai (via the `apply_feed_filters` SSE
 * event) to the shared `FeedContext`. A mounted `FeedProvider` picks up the
 * change via the `kai-feed-filters` window event. Applied only when the target
 * is the feed AND the user is on `/feed` — off-page asks stay in chat.
 */
export function useApplyKaiFeedFilters() {
  const location = useLocation();
  return useCallback(
    (page: unknown, filters: unknown) => {
      if (page !== "feed") return;
      if (!location.pathname.startsWith("/feed")) return;
      if (!filters || typeof filters !== "object") return;
      applyKaiFeedFilters(filters as KaiFeedFiltersPatch);
    },
    [location.pathname],
  );
}
